var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",style:(_vm.style),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.xlink}})])}
var staticRenderFns = []

export { render, staticRenderFns }